module.exports = __webpack_public_path__ + "static/media/400382_01.77b6783a.png";